import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {TimeoutResolve} from "./resolvers/timeout-resolve";
import {DictionaryService} from "./services/dictionary.service";
import {KeycloakService} from "./services/keycloak.service";
import {TableParserService} from "./services/table-parser.service";
import {WindowRefService} from "./services/window-ref.service";

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [],
  providers: [
    KeycloakService,
    DictionaryService,
    TimeoutResolve,
    TableParserService,
    WindowRefService
  ]
})
export class CoreModule {
}



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts